import React from "react";

export default function DotSeparatorIcon({ className = "svg-308-2", ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 4 4" fill="none" className={className} aria-hidden="true" {...props}>
      <circle cx="2" cy="2" r="2" fill="#94A3B8" />
    </svg>
  );
}
